import { useEffect, useState } from "react";
import { X, Plus } from "lucide-react";
import { api } from "@/lib/api";

export default function LookPicker({ value, onChange, selfSlug, label = "Complete the look", hint = "optional — pinned first; auto-filled by shared tags/categories", testId = "look-picker" }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) return setResults([]);
    let stale = false;
    const t = setTimeout(() => {
      api.get("/products", { params: { q: q.trim(), page_size: 8 } }).then((r) => {
        if (!stale) setResults(r.data.items.filter((p) => p.slug !== selfSlug && !value.includes(p.slug)));
      });
    }, 250);
    return () => { stale = true; clearTimeout(t); };
  }, [q, value, selfSlug]);

  return (
    <div data-testid={testId}>
      <label className="font-mono uppercase text-[10px] tracking-widest opacity-70 block mb-1">
        {label}{" "}
        <span className="opacity-60 normal-case tracking-normal">({hint})</span>
      </label>
      <div className="flex flex-wrap gap-2 mb-2">
        {value.map((s) => (
          <span key={s} className="brut pcs-bg-pink text-white px-2 py-1 font-mono text-[10px] inline-flex items-center gap-1" data-testid={`${testId}-chip-${s}`}>
            {s}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== s))} data-testid={`${testId}-chip-remove-${s}`}>
              <X className="w-3 h-3" strokeWidth={3} />
            </button>
          </span>
        ))}
      </div>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search products to pin..." data-testid={`${testId}-search`} className="w-full brut bg-white px-3 py-2 focus:outline-none text-sm" />
      {results.length > 0 && (
        <div className="brut bg-white mt-1 max-h-56 overflow-y-auto" data-testid={`${testId}-results`}>
          {results.map((p) => (
            <button
              type="button"
              key={p.slug}
              onClick={() => { onChange([...value, p.slug]); setQ(""); }}
              data-testid={`${testId}-add-${p.slug}`}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 flex items-center gap-2 border-b border-black/10"
            >
              <Plus className="w-3.5 h-3.5 shrink-0" strokeWidth={3} />
              <img src={p.image_url} alt="" className="w-8 h-8 object-cover border border-black" />
              <span className="truncate">{p.title}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
